"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrowserMicrofrontend = void 0;
var browser_1 = require("@cian/config/browser");
var BrowserMicrofrontend = /** @class */ (function () {
    function BrowserMicrofrontend(_a) {
        var instance = _a.instance;
        this.path = (0, browser_1.getConfig)().getStrict('pathApi');
        this.instance = instance;
    }
    BrowserMicrofrontend.prototype.start = function (options) {
        return this.instance.start(__assign(__assign({}, options), { path: this.path }));
    };
    BrowserMicrofrontend.prototype.getChild = function (mcs) {
        return this.instance.getChild(mcs);
    };
    return BrowserMicrofrontend;
}());
exports.BrowserMicrofrontend = BrowserMicrofrontend;
//# sourceMappingURL=BrowserMicrofrontend.js.map